<!-- src/app/navigation/admin-sidebar/admin-sidebar.component.html -->
<aside
  class="admin-sidebar"
  [class.compact]="isCompact && !isMobileMode"
  [class.mobile-mode]="isMobileMode"
  [class.open-on-mobile]="isMobileMode && isOpenOnMobile"
>
  <div class="sidebar-header">
    <a
      class="sidebar-brand"
      href="/dashboard"
      (click)="$event.preventDefault(); onDashboardClickImage()"
      [attr.aria-label]="'Home' | translate"
      [xdsTooltip]="isCompact && !isMobileMode ? ('Home' | translate) : ''"
      xdsTooltipPosition="right"
    >
      <picture>
        <source
          srcset="assets/img/icons/web-app-logo/logo-dark.svg"
          media="(prefers-color-scheme: dark)"
        />
        <img
          src="assets/img/icons/web-app-logo/logo-light.svg"
          alt="FixPlaner"
          width="40"
          height="40"
        />
      </picture>
      <img
        *ngIf="!isCompact || isMobileMode"
        src="assets/img/logo-text.svg"
        alt="FixPlaner"
        class="sidebar-brand-text"
      />
    </a>

    <xds-icon-button
      *ngIf="isMobileMode"
      variant="ghost"
      icon="fa-light fa-xmark"
      [ariaLabel]="'CLOSE' | translate"
      (clicked)="closeMobileSidebar()"
    ></xds-icon-button>

    <xds-icon-button
      *ngIf="!isMobileMode && authService.isManegeOrTeamLeader"
      variant="ghost"
      size="sm"
      data-testid="nav-toggle"
      [icon]="isCompact ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"
      [ariaLabel]="isCompact ? ('EXPAND_SIDEBAR' | translate) : ('COLLAPSE_SIDEBAR' | translate)"
      (clicked)="toggleCompact()"
    ></xds-icon-button>
  </div>

  <!-- Company Switcher for Multi-Company Users -->
  <app-company-switcher
    data-testid="nav-company-switcher"
    [isCompact]="isCompact"
    [isMobileMode]="isMobileMode"
  ></app-company-switcher>

  <nav class="sidebar-nav xds-nav-list" data-testid="nav-areas" [class.is-collapsed]="isCompact && !isMobileMode">
    <ul>
      <!-- Dashboard -->
      <li *ngIf="authService.isManegeOrTeamLeader">
        <a
          class="xds-nav-item"
          onboardingAnchor="nav-dashboard"
          data-testid="nav-dashboard"
          routerLink="/dashboard"
          routerLinkActive="is-active"
          (click)="onDashboardClick()"
          [attr.aria-label]="'DASHBOARD.TITLE' | translate"
          [xdsTooltip]="
            isCompact && !isMobileMode ? ('DASHBOARD.TITLE' | translate) : ''
          "
          xdsTooltipPosition="right"
        >
          <span class="xds-nav-item-icon"><i class="fas fa-desktop"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "DASHBOARD.TITLE" | translate }}</span>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>

      <li *ngIf="!authService.isManegeOrTeamLeader">
        <a
          class="xds-nav-item"
          onboardingAnchor="nav-dashboard"
          data-testid="nav-dashboard"
          routerLink="/employeedashboard"
          routerLinkActive="is-active"
          (click)="onEmployeeDashboardClick()"
          [attr.aria-label]="'DASHBOARD.TITLE' | translate"
          [xdsTooltip]="
            isCompact && !isMobileMode ? ('DASHBOARD.TITLE' | translate) : ''
          "
          xdsTooltipPosition="right"
        >
          <span class="xds-nav-item-icon"><i class="fas fa-desktop"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "DASHBOARD.TITLE" | translate }}</span>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>

      <!-- E1 (Planning-Redesign, 2026-06-10): Menüpunkt „Personalbedarf"
           entfernt — die Seite ist im ▦-Muster-Modus der fusionierten Planung
           (/planner?view=muster) aufgegangen; die alte Route leitet dorthin um.
           Rollback: Block aus Git-Historie (Commit vor E1-S7) wiederherstellen. -->

      <!-- Shift Planning (Planung) -->
      <ng-container *ngIf="authService.isManegeOrTeamLeader">
        <ng-container *ngIf="shiftPlanningVisibility$ | async as v">
          <li *ngIf="v === 'active'">
            <a class="xds-nav-item" onboardingAnchor="nav-planner" data-testid="nav-planner" routerLink="/planner" routerLinkActive="is-active" (click)="onPlannerClick()"
              [attr.aria-label]="'Planner' | translate"
              [xdsTooltip]="isCompact && !isMobileMode ? ('Planner' | translate) : ''"
              xdsTooltipPosition="right">
              <!-- Kalender, NICHT fa-tasks: das war ein Altname von fa-list-check (beide U+F0AE) und
                   damit buchstaeblich dasselbe Zeichen wie bei "Aufgaben" darunter. Bewusst `fa-solid`
                   und nicht `fa-light`: die Zeiterfassung fuehrt direkt darunter ein LEICHTES
                   fa-calendar-clock. Die unterschiedliche Strichstaerke ist das einzige, was die
                   beiden Kalender in der Rail noch auseinanderhaelt — wer hier auf light wechselt,
                   nimmt sie weg. -->
              <span class="xds-nav-item-icon"><i class="fa-solid fa-calendar-days"></i></span>
              <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "Planner" | translate }}</span>
              <span class="xds-nav-item-indicator" aria-hidden="true"></span>
            </a>
          </li>
          <li *ngIf="v === 'locked'" class="locked-nav-item">
            <!-- Wirkt nur in der kompakten Rail: im breiten Zustand rendert `locked-feature` ein
                 Schloss und ignoriert dieses Input (locked-feature.component.html:8). -->
            <app-locked-feature [feature]="Feature.SHIFT_PLANNING_BASIC" icon="fa-calendar-days"
              label="Planner" variant="sidebar" [isCompact]="isCompact && !isMobileMode">
            </app-locked-feature>
          </li>
        </ng-container>
      </ng-container>

      <!-- Aufgaben (Tasks) — A5, direkt NACH „Planung" (06-ENTRYPOINT-NAV §1).
           3-Zustands-Gate: nur bei *aktiv*/*locked* wird das Item gebaut; bei
           *versteckt* liefert tasksNavItem$ null → gar kein <li> (Pflicht-Negativtest).
           Badge = xds-badge (Zahl, danger nur bei Überfälligen). -->
      <li *ngIf="tasksNavItem$ | async as taskNav">
        <a class="xds-nav-item" onboardingAnchor="nav-tasks" data-testid="nav-tasks" routerLink="/tasks" routerLinkActive="is-active" (click)="onTasksClick()"
          [attr.aria-label]="taskNav.labelKey | translate"
          [xdsTooltip]="isCompact && !isMobileMode ? (taskNav.labelKey | translate) : ''"
          xdsTooltipPosition="right">
          <span class="xds-nav-item-icon"><i [class]="taskNav.icon"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ taskNav.labelKey | translate }}</span>
          <xds-badge *ngIf="taskNav.badge && (!isCompact || isMobileMode)"
            [variant]="taskNav.badgeVariant || 'info'">{{ taskNav.badge }}</xds-badge>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>
      <!-- Tarif enthält die Aufgaben nicht (Spark), der Nutzer hätte aber ein Recht: gesperrt zeigen
           statt verstecken — dasselbe Muster wie bei Planung/Verfügbarkeit/Zeiterfassung/Abwesenheit.
           `app-locked-feature` kümmert sich um Plan-Badge, Tooltip und die Apple-Regel (auf iOS ein
           Hinweis statt eines Links zur Abo-Seite). -->
      <li *ngIf="(tasksVisibility$ | async) === 'locked'" class="locked-nav-item">
        <app-locked-feature [feature]="Feature.TASK_MANAGEMENT" icon="fa-list-check"
          label="TASKS" variant="sidebar" [isCompact]="isCompact && !isMobileMode">
        </app-locked-feature>
      </li>

      <!-- Availability - active / locked / hidden -->
      <ng-container *ngIf="authService.isManegeOrTeamLeader">
        <ng-container *ngIf="availabilityVisibility$ | async as v">
          <li *ngIf="v === 'active'">
            <a class="xds-nav-item" onboardingAnchor="nav-availability" data-testid="nav-availability" routerLink="/availability" routerLinkActive="is-active" (click)="onAvailabilityClick()"
              [attr.aria-label]="'AVAILABILITY' | translate"
              [xdsTooltip]="isCompact && !isMobileMode ? ('AVAILABILITY' | translate) : ''"
              xdsTooltipPosition="right">
              <span class="xds-nav-item-icon"><i class="fa-light fa-user-check"></i></span>
              <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "AVAILABILITY" | translate }}</span>
              <span class="xds-nav-item-indicator" aria-hidden="true"></span>
            </a>
          </li>
          <li *ngIf="v === 'locked'" class="locked-nav-item">
            <app-locked-feature [feature]="Feature.SHIFT_SWAP_ADVANCED" icon="fa-user-check"
              label="AVAILABILITY" variant="sidebar" [isCompact]="isCompact && !isMobileMode">
            </app-locked-feature>
          </li>
        </ng-container>
      </ng-container>

      <!-- Employee Management -->
      <li *ngIf="authService.isManegeOrTeamLeader">
        <a
          class="xds-nav-item"
          onboardingAnchor="employee-page"
          data-testid="nav-employee"
          routerLink="/employee"
          routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="onEmployeeClick()"
          [attr.aria-label]="'Employee' | translate"
          [xdsTooltip]="
            isCompact && !isMobileMode ? ('Employee' | translate) : ''
          "
          xdsTooltipPosition="right"
        >
          <span class="xds-nav-item-icon"><i class="fa-solid fa-users-gear"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{
            "Employee" | translate
          }}</span>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>

      <!-- Organization -->
      <li *ngIf="showOrganization$ | async">
        <a
          class="xds-nav-item"
          onboardingAnchor="nav-organization"
          data-testid="nav-organization"
          routerLink="/organization"
          routerLinkActive="is-active"
          (click)="onOrganizationClick()"
          [attr.aria-label]="'ORGANIZATION' | translate"
          [xdsTooltip]="
            isCompact && !isMobileMode ? ('ORGANIZATION' | translate) : ''
          "
          xdsTooltipPosition="right"
        >
          <span class="xds-nav-item-icon"><i class="fas fa-sitemap"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{
            "ORGANIZATION" | translate
          }}</span>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>

      <!-- Time Tracking - active / locked / hidden -->
      <ng-container *ngIf="authService.isManegeOrTeamLeader">
        <ng-container *ngIf="timeTrackingVisibility$ | async as v">
          <li *ngIf="v === 'active'">
            <a class="xds-nav-item" onboardingAnchor="nav-time-recording" data-testid="nav-time-recording" routerLink="/time-recording" routerLinkActive="is-active" (click)="onTimeRecordingClick()"
              [attr.aria-label]="'TIME TRACKING' | translate"
              [xdsTooltip]="isCompact && !isMobileMode ? ('TIME TRACKING' | translate) : ''"
              xdsTooltipPosition="right">
              <span class="xds-nav-item-icon"><i class="fa-light fa-calendar-clock"></i></span>
              <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "TIME TRACKING" | translate }}</span>
              <span class="xds-nav-item-indicator" aria-hidden="true"></span>
            </a>
          </li>
          <li *ngIf="v === 'locked'" class="locked-nav-item">
            <app-locked-feature [feature]="Feature.TIME_TRACKING_BASIC" icon="fa-calendar-clock"
              label="TIME TRACKING" variant="sidebar" [isCompact]="isCompact && !isMobileMode">
            </app-locked-feature>
          </li>
        </ng-container>
      </ng-container>

      <!-- Absence - active / locked / hidden -->
      <ng-container *ngIf="authService.isManegeOrTeamLeader">
        <ng-container *ngIf="absenceVisibility$ | async as v">
          <li *ngIf="v === 'active'">
            <a class="xds-nav-item" onboardingAnchor="nav-absence" data-testid="nav-absence" routerLink="/absence" routerLinkActive="is-active" (click)="onAbsenceClick()"
              [attr.aria-label]="'Absence' | translate"
              [xdsTooltip]="isCompact && !isMobileMode ? ('Absence' | translate) : ''"
              xdsTooltipPosition="right">
              <span class="xds-nav-item-icon"><i class="fa-light fa-house-person-leave"></i></span>
              <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{ "Absence" | translate }}</span>
              <span class="xds-nav-item-indicator" aria-hidden="true"></span>
            </a>
          </li>
          <li *ngIf="v === 'locked'" class="locked-nav-item">
            <app-locked-feature [feature]="Feature.ABSENCE_MANAGEMENT_BASIC" icon="fa-house-person-leave"
              label="Absence" variant="sidebar" [isCompact]="isCompact && !isMobileMode">
            </app-locked-feature>
          </li>
        </ng-container>
      </ng-container>

      <!-- Hier stand bis zum 14.09.2026 „Ausstehende Tauschgenehmigungen" mit Zähler-Abzeichen
           (Route `/shift-swap-approvals`). Entfallen, weil dieselbe Liste über ZWEI Oberflächen
           erreichbar war — eine Vollseite hier und ein Pop-up im Planer. Der Manager entscheidet
           Tausche dort, wo er den Dienstplan sieht; die Seite war die redundante Hälfte.
           Der Zähler ist mitgewandert und sitzt jetzt am Planer-Knopf „Tausche (N)" sowie am
           gleichnamigen Eintrag seines ⋯-Menüs (`updateSwapApprovalButtonCount`). Er DARF nicht
           ersatzlos verschwinden: `AcceptSwapAsync` benachrichtigt beim Übergang in den
           Wartezustand nur den Antragsteller — ohne diese Zahl erfährt der Manager nirgends,
           dass etwas auf ihn wartet. Das Gate dazu lebt weiter in `swap-shift/gate.ts` und wird
           jetzt vom Planer ausgewertet. -->

      <!-- Settings -->
      <li *ngIf="authService.isManegeOrTeamLeader && userPermissions.CurrentUserPermissions?.Settings?.CanViewCompanySettings">
        <a
          class="xds-nav-item"
          onboardingAnchor="nav-settings"
          data-testid="nav-settings"
          routerLink="/settings"
          routerLinkActive="is-active"
          (click)="onSettingsClick()"
          [attr.aria-label]="'SETTINGS.TITLE' | translate"
          [xdsTooltip]="
            isCompact && !isMobileMode ? ('SETTINGS.TITLE' | translate) : ''
          "
          xdsTooltipPosition="right"
        >
          <span class="xds-nav-item-icon"><i class="fa-light fa-gears"></i></span>
          <span class="xds-nav-item-label" *ngIf="!isCompact || isMobileMode">{{
            "SETTINGS.TITLE" | translate
          }}</span>
          <span class="xds-nav-item-indicator" aria-hidden="true"></span>
        </a>
      </li>
    </ul>
  </nav>
</aside>

<!-- Overlay für Mobile -->
<div
  class="mobile-sidebar-overlay"
  *ngIf="isMobileMode && isOpenOnMobile"
  (click)="closeMobileSidebar()"
></div>
